<template>
    <b-modal
        id="module-index-create-module"
        v-model="modal"
        ref="module-index-create-module"
        :title="$t('modules.add_module')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        ok-variant="primary"
        @ok="onOk"
        size="xl"
        modal-class="apprentice-default-modal modules-index-add-module-modal"
        :no-enforce-focus="true">
        <div class="modules-index-form">
            <div class="default-section">
                <div
                    class="module-banner-preview"
                    v-if="banner_preview !== ''">
                    <b-img :src="banner_preview"></b-img>
                </div>

                <div
                    class="errors"
                    v-if="hasErrors">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('modules.form_not_filled_in_correctly') }}</b-alert
                    >
                </div>

                <div
                    class="errors"
                    v-if="errorTitle">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('modules.title_cannot_be_empty') }}</b-alert
                    >
                </div>
                <div class="group-info">
                    <b-form-group
                        class="group-input-title"
                        label-for="module-title-input">
                        <label>
                            {{ $t('common.title') }}
                            <span class="required">*</span>
                        </label>
                        <b-form-input
                            id="module-title-input"
                            v-model="title"
                            :placeholder="$t('common.title')"></b-form-input>
                    </b-form-group>

                    <b-form-group
                        class="group-input-location"
                        :label="$t('common.location')"
                        label-for="module-location-input">
                        <b-form-input
                            id="module-location-input"
                            v-model="location"
                            :placeholder="$t('common.location')"></b-form-input>
                    </b-form-group>

                    <b-form-group
                        class="group-input-file"
                        :label="$t('modules.image')"
                        label-for="module-banner-input">
                        <b-form-file
                            class="apprentice-file-upload"
                            id="module-banner-input"
                            v-model="file"
                            accept="image/jpeg"
                            :placeholder="$t('modules.upload_banner')"
                            @change="showPreview"></b-form-file>
                    </b-form-group>

                    <!--                    <b-form-group label="Video" label-for="module-video-input" class="group-input-video">-->
                    <!--                        <b-form-file class="apprentice-file-upload" id="module-video-input" v-model="video"-->
                    <!--                                     accept="video/mp4" placeholder="video uploaden"></b-form-file>-->
                    <!--                    </b-form-group>-->
                </div>

                <div
                    class="errors"
                    v-if="errorDescription">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('modules.description_cannot_be_empty') }}</b-alert
                    >
                </div>
                <b-form-group
                    class="group-input-description"
                    label-for="module-description-input">
                    <label>
                        {{ $t('common.description') }}
                        <span class="required">*</span>
                    </label>
                    <ckeditor
                        v-model="description"
                        :editor="editor"
                        :config="editorConfig"></ckeditor>
                </b-form-group>

                <div class="group-select">
                    <div
                        class="errors"
                        v-if="errorCustomTag">
                        <b-alert
                            show
                            variant="danger">
                            {{ $t('modules.tag_not_chosen_or_not_unique') }}
                        </b-alert>
                    </div>
                    <div
                        class="errors"
                        v-if="errorCustomTagColor">
                        <b-alert
                            show
                            variant="danger"
                            >{{ $t('modules.tag_color_cannot_be_empty') }}</b-alert
                        >
                    </div>
                    <div class="tags">
                        <b-form-group
                            class="group-input-tags"
                            label-for="module-tags-input">
                            <label>
                                Tag
                                <span class="required">*</span>
                            </label>
                            <design-2021-apprentice-multiselect-component
                                class="tags-select"
                                id="module-tags-input"
                                :placeholder="$t('modules.choose_or_search_tag')"
                                label="name"
                                :multiple-select="false"
                                :options="tags"
                                :show-labels="false"
                                @input="updated($event)"
                                :selected-in="selectedTags">
                                <template
                                    slot="singleLabel"
                                    slot-scope="props">
                                    <div class="tag">
                                        <i
                                            class="fas fa-fw"
                                            :class="props.option.id === null ? 'fa-plus-circle' : 'fa-circle'"
                                            :style="{ color: props.option.color }"></i
                                        >{{ props.option.name }}
                                    </div>
                                </template>

                                <template
                                    slot="option"
                                    slot-scope="props">
                                    <div class="tag">
                                        <i
                                            class="fas fa-fw"
                                            :class="props.option.id === null ? 'fa-plus-circle' : 'fa-circle'"
                                            :style="{ color: props.option.color }"></i
                                        >{{ props.option.name }}
                                    </div>
                                </template>
                            </design-2021-apprentice-multiselect-component>
                        </b-form-group>

                        <b-form-group
                            class="group-input-new-tag"
                            v-if="selectedTags && selectedTags.id === null"
                            :label="$t('modules.new_tag')"
                            label-for="module-new-tag-input">
                            <b-form-input
                                id="module-new-tag-input"
                                v-model="createdTag"
                                :placeholder="$t('modules.create_tag')"></b-form-input>
                        </b-form-group>

                        <b-form-group
                            class="group-input-new-tag-color"
                            v-if="selectedTags && selectedTags.id === null"
                            :label="$t('modules.tag_color')"
                            label-for="module-new-tag-color-input">
                            <design-2021-colorpicker
                                id="module-new-tag-color-input"
                                :color="tagColor"
                                @on-close="addColorToTag"></design-2021-colorpicker>
                        </b-form-group>
                    </div>

                    <div class="group-input-education-level">
                        <div
                            class="errors"
                            v-if="errorLevels">
                            <b-alert
                                show
                                variant="danger"
                                >{{ $t('modules.level_cannot_be_empty') }}</b-alert
                            >
                            <b-form-group label-for="module-education-level-input">
                                <label>
                                    {{ $t('modules.level') }}
                                    <span class="required">*</span>
                                </label>
                                <design-2021-apprentice-multiselect-component
                                    id="module-education-level-input"
                                    v-model="selectedEducationLevels"
                                    :placeholder="'Kies of zoek een niveau'"
                                    label="name"
                                    :multiple-select="true"
                                    :options="educationLevelsIn"
                                    :selected-in="selectedEducationLevels"
                                    :show-labels="false">
                                </design-2021-apprentice-multiselect-component>
                            </b-form-group>
                        </div>

                        <b-form-group
                            class="group-input-skill-tree-level"
                            :label="$t('modules.skills')"
                            label-for="module-skill-tree-input">
                            <design-2021-apprentice-multiselect-component
                                id="module-skill-tree-input"
                                v-model="selectedSkillTree"
                                :placeholder="$t('modules.choose_or_search_skill')"
                                label="name"
                                :multiple-select="true"
                                :options="skillTreesIn"
                                :selected-in="selectedSkillTree"
                                :show-labels="false">
                            </design-2021-apprentice-multiselect-component>
                        </b-form-group>

                        <div class="teacher-skills">
                            <b-form-group
                                class="group-input-skills"
                                :label="$t('modules.competences')"
                                label-for="module-skills-input">
                                <design-2021-apprentice-multiselect-component
                                    id="module-skills-input"
                                    v-model="selectedSkills"
                                    :placeholder="$t('modules.choose_or_search_competence')"
                                    label="name"
                                    :options="getSkills()"
                                    :selected-in="selectedSkills"
                                    :multiple-select="true"
                                    :show-labels="false">
                                </design-2021-apprentice-multiselect-component>
                            </b-form-group>

                            <div class="group-input-teachers">
                                <div
                                    class="errors"
                                    v-if="errorTeachers">
                                    <b-alert
                                        show
                                        variant="danger"
                                        >{{ $t('modules.teachers_cannot_be_empty') }}
                                    </b-alert>
                                </div>
                                <b-form-group label-for="module-teachers-input">
                                    <label>
                                        {{ $t('modules.teachers') }}
                                        <span class="required">*</span>
                                    </label>
                                    <design-2021-apprentice-multiselect-component
                                        id="module-teachers-input"
                                        v-model="selectedTeachers"
                                        :placeholder="$t('modules.search_a_teacher')"
                                        label="full_name"
                                        :multiple-select="true"
                                        :options="teachersIn"
                                        :selected-in="selectedTeachers"
                                        :show-labels="false">
                                    </design-2021-apprentice-multiselect-component>
                                </b-form-group>
                            </div>

                            <b-form-group
                                class="group-input-lasgroups"
                                :label="$t('modules.link_class')"
                                label-for="module-lasgroups-input">
                                <design-2021-apprentice-multiselect-component
                                    id="module-lasgroups-input"
                                    v-model="selectedLasGroups"
                                    :placeholder="$t('modules.choose_or_search_las_group')"
                                    label="name"
                                    :multiple-select="false"
                                    :options="lasGroupsIn"
                                    :selected-in="selectedLasGroups"
                                    :show-labels="false">
                                </design-2021-apprentice-multiselect-component>
                            </b-form-group>
                        </div>
                    </div>
                </div>

                <div class="availability">
                    <div
                        class="errors"
                        v-if="errorDates">
                        <b-alert
                            show
                            variant="danger">
                            {{ $t('modules.error_in_time_blocks_required_fields') }}
                        </b-alert>
                    </div>

                    <design-2021-module-index-availability-form-component
                        :module-dates-in="moduleDates"
                        :module-periods-in="modulePeriodsIn"
                        @change="moduleDatesUpdate">
                    </design-2021-module-index-availability-form-component>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';
import ApprenticeEditor from '../../../helpers/ApprenticeEditor';
import $ from 'jquery';

const moduleOrds = ords.use('module');

export default {
    name: 'design-2021-module-index-create-module-modal-component',
    props: {
        tagsIn: Array,
        educationLevelsIn: Array,
        skillTreesIn: Array,
        teachersIn: Array,
        lasGroupsIn: Array,
        modulePeriodsIn: Array,
    },
    data() {
        return {
            id: null,
            modal: false,
            title: '',
            description: '',
            file: null,
            // video: null,
            moduleDates: [
                {
                    duration: null,
                    modulePeriodId: null,
                    max: null,
                },
            ],
            tags: [],
            selectedTags: [],
            createdTag: '',
            location: '',
            tagColor: '#000000',
            selectedEducationLevels: [],
            selectedSkillTree: [],
            selectedSkills: [],
            banner_preview: '',
            hasErrors: false,
            errorTitle: false,
            errorDescription: false,
            errorCustomTag: false,
            errorCustomTagColor: false,
            errorLevels: false,
            errorTeachers: false,
            errorDates: false,
            editor: ApprenticeEditor,
            useExistingFileId: null,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'blockQuote',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                simpleUpload: {},
            },
            selectedTeachers: [],
            selectedLasGroups: [],
        };
    },
    methods: {
        show(module = null) {
            if (module) {
                this.title = module.title;
                this.description = module.description;
                this.selectedTags = module.module_tags[0];
                this.location = module.location;
                this.selectedEducationLevels = module.education_levels;
                this.banner_preview = module.file ? module.file.public_path : '';
                this.selectedSkillTree = module.module_skill_trees.map((moduleSkillTree) => {
                    return this.skillTreesIn.find((tree) => tree.id === moduleSkillTree.skill_tree_id);
                });
                this.selectedSkills = module.module_skills.map((skill0) => {
                    return this.getSkills().find((skill1) => skill1.id === skill0.id);
                });
                this.useExistingFileId = module.file_id;
            } else {
                this.banner_preview = '';
                this.title = '';
                this.description = '';
                this.selectedTags = [];
                this.location = '';
                this.selectedEducationLevels = [];
                this.selectedSkillTree = [];
                this.selectedSkills = [];
            }

            this.id = null;
            this.tagColor = '#000000';
            this.createdTag = '';
            this.moduleDates = [
                {
                    duration: null,
                    modulePeriodId: null,
                    max: null,
                },
            ];
            this.file = null;
            this.selectedLasGroups = [];
            this.errorTitle = false;
            this.errorDescription = false;
            this.errorCustomTag = false;
            this.errorCustomTagColor = false;
            this.errorLevels = false;
            this.errorTeachers = false;
            this.errorDates = false;

            this.modal = true;
        },
        getSkills() {
            let skills = [];

            for (const skilltree of this.selectedSkillTree) {
                if (skilltree === undefined) {
                    continue;
                }
                for (const tree of skilltree.skill_skill_trees) {
                    if (tree.skill) {
                        skills.push(tree.skill);
                    }
                }
            }

            return skills;
        },
        onOk(evt) {
            if (this.checkForErrors()) {
                evt.preventDefault();

                Vue.nextTick(() => {
                    $('#module-index-create-module').animate({ scrollTop: 0 }, 500);
                });

                return;
            }

            const data = new FormData();
            const options = {
                headers: { 'Content-Type': 'multipart/form-data' },
            };

            data.append('title', this.title);
            data.append('location', this.location);
            data.append('description', this.description);
            data.append('file', this.file);

            if (this.selectedLasGroups.length) {
                data.append('las_group', parseInt(this.selectedLasGroups.id));
            }

            if (this.selectedTags.id === null) {
                data.append('tag', this.createdTag);
                data.append('tag_color', this.tagColor);
            } else {
                data.append('tag_id', this.selectedTags.id);
            }

            for (const [index, date] of this.selectedTeachers.entries()) {
                for (const key of Object.keys(date)) {
                    data.append(`teachers[${index}][${key}]`, date[key]);
                }
            }

            for (const [index, date] of this.moduleDates.entries()) {
                for (const key of Object.keys(date)) {
                    if (!date[key]) {
                        continue;
                    }
                    if (key === 'modulePeriod') {
                        data.append(`items[${index}][${key}]`, date[key].id);
                    } else {
                        data.append(`items[${index}][${key}]`, date[key]);
                    }
                }
            }

            for (const [index, date] of this.selectedSkills.entries()) {
                for (const key of Object.keys(date)) {
                    if (!date[key]) {
                        continue;
                    }
                    data.append(`skills[${index}][${key}]`, date[key]);
                }
            }

            for (const [index, date] of this.selectedSkillTree.entries()) {
                for (const key of Object.keys(date)) {
                    if (!date[key]) {
                        continue;
                    }
                    data.append(`skill_trees[${index}][${key}]`, date[key]);
                }
            }

            for (const [index, date] of this.selectedEducationLevels.entries()) {
                for (const key of Object.keys(date)) {
                    data.append(`levels[${index}][${key}]`, date[key]);
                }
            }

            if (this.useExistingFileId) {
                data.append('file_id', this.useExistingFileId);
            }

            this.alert.saving();

            this.axios.post(this.routes.addModule(), data, options).then(
                (response) => {
                    moduleOrds.add(response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        moduleDatesUpdate(dates) {
            this.moduleDates = dates;
        },
        updated(checked) {
            if (checked.id !== null) {
                this.createdTag = '';
            }
            this.selectedTags = checked;
        },
        checkForErrors() {
            this.hasErrors = false;
            this.errorTitle = false;
            this.errorDescription = false;
            this.errorCustomTag = false;
            this.errorCustomTagColor = false;
            this.errorLevels = false;
            this.errorTeachers = false;

            if (this.start_date === null || this.end_date === null) {
                this.hasErrors = true;
                this.errorDates = true;
            }

            if (this.title === '') {
                this.hasErrors = true;
                this.errorTitle = true;
            }

            if (this.description === '') {
                this.hasErrors = true;
                this.errorDescription = true;
            }

            if (
                this.selectedTags.length === 0 ||
                (this.selectedTags.length > 0 && this.createdTag === '' && this.selectedTags.id === null) ||
                (this.createdTag !== '' &&
                    this.tags.map((tag) => tag.name.toLowerCase()).indexOf(this.createdTag.toLowerCase()) !== -1)
            ) {
                this.hasErrors = true;
                this.errorCustomTag = true;
            }

            if (this.tagColor === '') {
                this.hasErrors = true;
                this.errorCustomTagColor = true;
            }

            if (this.selectedEducationLevels.length === 0) {
                this.hasErrors = true;
                this.errorLevels = true;
            }

            if (this.selectedTeachers.length === 0) {
                this.hasErrors = true;
                this.errorTeachers = true;
            }

            for (const dateItem of this.moduleDates) {
                if (
                    dateItem.modulePeriodId === null ||
                    dateItem.modulePeriodId === '' ||
                    dateItem.max === null ||
                    dateItem.max === ''
                ) {
                    this.hasErrors = true;
                    this.errorDates = true;
                    break;
                }
            }

            return this.hasErrors;
        },
        addColorToTag(color) {
            this.tagColor = color;
        },
        showPreview(evt) {
            const file = evt.target.files[0];
            this.banner_preview = URL.createObjectURL(file);
        },
    },
    mounted() {
        for (const teacher of this.teachersIn) {
            if (teacher.id === this.$authUser.id) {
                this.selectedTeachers.push(teacher);
            }
        }

        this.tags = [{ name: this.$t('modules.add_tag'), id: null, color: '#007bff' }, ...this.tagsIn];
    },
};
</script>

<style scoped lang="scss">
::v-deep .apprentice-multiselect {
    .multiselect__tags {
        height: 49px;
    }
}

.form-group {
    label {
        display: block !important;
    }
}

.module-banner-preview {
    margin-bottom: $grid-gutter-width;

    img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 150px;
    }
}

.group-info {
    display: flex;
    flex-direction: column;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    > div:not(:last-child) {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }

    .apprentice-file-upload {
        margin-bottom: 0;
        min-height: 51px;
    }

    .module-image-upload,
            //.module-video-upload {
            //    label {
            //        margin-bottom: 0;
            //    }
            //}

        .form-control {
        margin-bottom: 0;
    }
}

.group-select {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one') * 2;
}

.apprentice-multiselect ::v-deep {
    .multiselect__option .tag i,
    .multiselect__tags .tag i {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}

.color-picker ::v-deep {
    .color-picker-container {
        height: inherit !important;

        .current-color {
            display: flex;
            border-top-right-radius: $border-radius-content;
            border-bottom-right-radius: $border-radius-content;
        }

        i {
            color: $white !important;
            height: auto !important;
            align-self: center;
            border: none;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .group-info,
    .group-select {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        > div {
            flex: 1 1 calc(50% - 15px);

            &:nth-child(odd) {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }

        .location-group {
            flex: 1 1 calc(25% - 15px);
        }

        .tags {
            flex: 1 0 100%;
        }

        div.group-input-skill-tree-level {
            margin-right: 0;
            margin-left: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .tags {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        > div {
            flex: 1 1 calc(33.3333% - 15px);

            &:not(:last-child) {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }

        .form-control {
            margin-bottom: 0;
        }
    }

    .teacher-skills {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');

        > div {
            flex: 1 1 calc(33% - 15px);
        }
    }
}
</style>
